module.exports = __webpack_public_path__ + "static/media/image-from-mars-3.png";